module.exports = __webpack_public_path__ + "img/drafts.0dbe34e1.svg";